// src/hooks/useAuth.js
import { useEffect } from 'react';
import useAuthStore from '../store/authStore';

export const useAuth = () => {
  const { 
    token, 
    user, 
    loading, 
    error,
    isAuthenticated: isAuth,
    login: storeLogin,
    logout: storeLogout,
    getUser,
    getToken,
    checkAuth,
    updateUser,
    clearError,
    initialize
  } = useAuthStore();

  // Initialize on mount
  useEffect(() => {
    initialize();
  }, [initialize]);

  // Login wrapper
  const login = async (email, password) => {
    const result = await storeLogin(email, password);
    return result;
  };

  // Logout wrapper
  const logout = async () => {
    await storeLogout();
  };

  return {
    // State
    token,
    user,
    loading,
    error,
    isAuthenticated: isAuth,
    
    // Methods
    login,
    logout,
    getUser,
    getToken,
    checkAuth,
    updateUser,
    clearError
  };
};

export default useAuth;